import { Component } from '@angular/core';
import { MegamenuComponent } from '../../megamenu/megamenu.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { CompanyConfigService, CompanyConfig } from '../../../services/company-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-spider-control',
  templateUrl: './spider-control.component.html',
  styleUrl: './spider-control.component.css',
  imports: [MegamenuComponent, FooterComponent, MatButtonModule, MatIconModule, MatCardModule, CommonModule]
})
export class SpiderControlComponent {
  config: CompanyConfig;

  spiderTypes = [
    { name: 'Black Widow', description: 'Venomous spider with distinctive red hourglass marking, found in Utah', danger: 'High' },
    { name: 'House Spider', description: 'Common indoor spider that builds webs in corners and basements', danger: 'Low' },
    { name: 'Wolf Spider', description: 'Large hunting spider that doesn\'t build webs, common in Utah yards', danger: 'Low' },
    { name: 'Cellar Spider', description: 'Long-legged spider found in basements and crawl spaces', danger: 'Low' },
    { name: 'Orb Weaver', description: 'Garden spider that builds large circular webs outdoors', danger: 'Low' },
    { name: 'Jumping Spider', description: 'Small, agile spider that hunts during the day', danger: 'Low' }
  ];

  treatmentAreas = [
    { area: 'Web Removal', description: 'Complete removal of existing webs and egg sacs' },
    { area: 'Perimeter Treatment', description: 'Exterior barrier to prevent spider entry' },
    { area: 'Indoor Treatment', description: 'Targeted treatment of hiding spots and corners' },
    { area: 'Exclusion Work', description: 'Sealing cracks and entry points' }
  ];

  constructor(
    private companyConfig: CompanyConfigService,
    private router: Router
  ) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  navigateToContact() {
    this.router.navigate(['/contact']);
  }

  getDangerColor(danger: string): string {
    switch (danger) {
      case 'High': return '#dc3545';
      case 'Medium': return '#ffc107';
      case 'Low': return '#28a745';
      default: return '#6c757d';
    }
  }
}